// extracted by mini-css-extract-plugin
export default {"value":"PileParametersSection_value__sIT59","wrapper":"PileParametersSection_wrapper__FbjpZ"};